import { axiosInstance } from '@/modules/shared/lib/axios'
import { GetPayrollDriversQuery, PayrollDriversResponse } from './types'

type Props = GetPayrollDriversQuery

export function getGroupedTimesheet(props: Props) {
  // POST with the explicit driver list + showBonusConfiguration, identical to
  // the timesheet view (TimesheetService.getGroupedTimesheets). This fetches
  // data for the drivers selected in the side panel, so newly added drivers
  // are loaded when the selection changes.
  return axiosInstance.post<PayrollDriversResponse>(
    `/api/${props.companyId}/timesheet/groupedTimesheet`,
    {
      companyId: props.companyId,
      drivers: props.driversIds,
      year: props.year,
      month: props.month,
      showBonusConfiguration: props.showBonusConfiguration ?? true,
      // Forwarded for parity with the toolbar start/end toggle; harmless if the
      // backend ignores it on the POST variant.
      domesticBusinessTripDateType:
        props.domesticBusinessTripDateType || undefined,
      includeDomesticBusinessTrip: true,
    },
  )
}
